import { Component, forwardRef, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MaintenanceTypeApi } from '@api/maintenanceType.api';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { MaintenanceType, PagedResult } from '@interfaces';
import { debounceTime } from 'rxjs/operators';
import english from '../../../../../main/maintenances/i18n/en.json';
import spanish from '../../../../../main/maintenances/i18n/es.json';
import portuguese from '../../../../../main/maintenances/i18n/pt.json';

const INPUT_FIELD_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => MaintenanceTypeLegacyComponent),
  multi: true
};

@Component({
  selector: 'maintenance-type-legacy',
  templateUrl: './maintenance-type.component.html',
  styleUrls: ['./maintenance-type.component.scss'],
  providers: [INPUT_FIELD_VALUE_ACCESSOR],
  encapsulation: ViewEncapsulation.None
})
export class MaintenanceTypeLegacyComponent implements ControlValueAccessor {
  public maintenancesTypes: MaintenanceType[] = [];
  public selectedMaintenanceType: MaintenanceType;
  public hasSelectedMaintenanceType: boolean;

  public inputValue = new FormControl();
  public loading = false;

  constructor(
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private maintenanceTypeApi: MaintenanceTypeApi
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({english, portuguese, spanish});
    this.inputValue.valueChanges
      .pipe(debounceTime(500))
      .subscribe((value: string | null) => {
        this.maintenancesTypes = [];

        if (value) {
          this.searchMaintenancesTypes({ name_contains: value });
        }
      });
  }

  searchMaintenancesTypes(query: any): void {
    const orderBy = {
      orderColumn: 'name',
      order: 'asc',
    };

    this.loading = true;
    this.maintenanceTypeApi.search(query, orderBy).subscribe((result: PagedResult) => {
      this.loading = false;
      this.maintenancesTypes = result.items;
    });
  }

  writeValue(maintenanceTypeId: string): void {
    if (!maintenanceTypeId) {
      return this.deselectMaintenanceType();
    }

    this.maintenanceTypeApi.searchOne(maintenanceTypeId).then((maintenanceType) => {
      this.selectedMaintenanceType = maintenanceType;
      this.hasSelectedMaintenanceType = true;
      this.inputValue.setErrors(null);
    });
  }

  setSelectedMaintenanceType(): void {
    const { value } = this.inputValue;

    if (value) {
      this.onChange(value);
      this.selectedMaintenanceType = this.maintenancesTypes
        .find((maintenanceType) => maintenanceType.id === value);

      this.hasSelectedMaintenanceType = true;
      this.inputValue.setErrors(null);
    }
  }

  deselectMaintenanceType(): void {
    this.onChange(null);
    this.selectedMaintenanceType = null;
    this.hasSelectedMaintenanceType = false;
    this.inputValue.setValue(null);
    this.inputValue.setErrors(null);
  }

  onChange: (_: any) => void = () => {};
  onTouched: (_: any) => void = () => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
